import { FC } from "react";
import { useSelector } from "react-redux";
import { PAGE_IDS, SummaryStatus } from "../../helpers/constants";
import { BulkProcessCategoryEnum } from "../../helpers/types/common";
import { getProcessCategoryEnum } from "../../helpers/utils";
import { selectedBulkProcessSelector } from "../../redux/slices/manageBulkProcess/manageBulkProcessSelector";
import BulkCreateProgram from "../bulkCreateProgram/BulkCreateProgram";
import BulkEditProgram from "../bulkEditProgram/BulkEditProgram";
import CreateBulkActivity from "../createBulkActivity/CreateBulkActivity";
import CreateBulkTransfer from "../createBulkTransfer/CreateBulkTransfer";

const pageId = PAGE_IDS.MANAGE_BULK_PROGRAM_PROCESS;

const BulkManageProgram: FC = () => {
  const selectedProcess = useSelector(selectedBulkProcessSelector);

  const StepValuesByStatus = {
    [SummaryStatus.COMPLETED]: 2,
    DEFAULT: 1,
  } as const;
  //if completed then 2 else 1

  const stepValue =
    StepValuesByStatus[
      selectedProcess.status as keyof typeof StepValuesByStatus
    ] ?? StepValuesByStatus.DEFAULT;

  const processCategory: BulkProcessCategoryEnum = getProcessCategoryEnum(
    selectedProcess?.category,
  );

  switch (processCategory) {
    case BulkProcessCategoryEnum.EDIT:
      return (
        <BulkEditProgram
          initialStep={stepValue}
          status={selectedProcess.status}
          bulkImportId={selectedProcess.bulkProgramImportId}
          pageId={pageId}
          isEditViewOnly
        />
      );

    case BulkProcessCategoryEnum.CREATE:
      return (
        <BulkCreateProgram
          pageId={pageId}
          bulkImportId={selectedProcess.bulkProgramImportId}
          isAddViewOnly={true}
          stepValue={stepValue}
          status={selectedProcess.status}
        />
      );

    case BulkProcessCategoryEnum.INSERT_ACTIVITIES:
      return (
        <CreateBulkActivity
          stepValue={stepValue}
          status={selectedProcess.status}
          bulkImportId={selectedProcess.bulkProgramImportId}
          isFromManageBulkProcessFlow
        />
      );

    case BulkProcessCategoryEnum.TRANSFER_PARTICIPANTS:
      return (
        <CreateBulkTransfer
          stepValue={stepValue}
          status={selectedProcess.status}
          bulkImportId={selectedProcess.bulkProgramImportId}
          isFromManageBulkProcessFlow
        />
      );

    default:
      return null;
  }
};

export default BulkManageProgram;
